import useIsEditorReady from './useIsEditorReady';
import useIsSaving from './useIsSaving';

export default function useIsInteractionDisabled() {
  const { isSaving } = useIsSaving();
  const { isReady } = useIsEditorReady();

  return {
    isInteractionDisabled: !isReady || isSaving,
  };
}
